<template>
    <v-app id="app-wrapper">
        <v-app-bar
                app
                color="primary"
                dark
                height="75"
        >
            <a @click="showMenu=!showMenu">
                <v-icon large>menu</v-icon>
            </a>
            <div v-if="branding && branding.logoUrl">
                <router-link to="/">
                    <img
                            :src="branding.logoUrl"
                            class="logo-top"
                    />
                </router-link>
            </div>

            <v-spacer></v-spacer>

            <div @click="$router.push('/register')" class="mr-3" v-if="!loggedIn && $route.path != '/register'">
                <v-btn color="yellow" small>Register</v-btn>
            </div>
            <div class="ml-3" v-if="loggedIn">
                <a @click="$router.push('/cart')">
                    <v-icon dark left>mdi-cart</v-icon>
                    <v-badge :content="cartSize" color="error" overlap v-if="cartSize>0"></v-badge>
                </a>
            </div>

        </v-app-bar>
        <v-content>
            <v-progress-linear color="primary darken-1"
                               indeterminate
                               v-if="executing"
            ></v-progress-linear>

            <v-navigation-drawer
                    absolute
                    class="dark_primary"
                    temporary
                    v-model="showMenu"
            >
                <v-list
                        class="py-0"
                        dense
                        nav
                >

                    <v-list-item @click="$router.push('/')" link v-if="$route.fullPath != '/'">
                        <v-list-item-icon>
                            <v-icon color="white" >home</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content class="white-text">
                            <v-list-item-title class="white--text">Home</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$router.push('/locations')" link v-if="loggedIn && $route.fullPath != '/locations'">
                        <v-list-item-icon>
                            <v-icon color="white">shop</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">Shop</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- <v-list-item @click="$router.push('/about')" link v-if="$route.fullPath != '/about'">
                        <v-list-item-icon>
                            <v-icon color="white">info</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">About</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->

                    <v-list-item @click="logout" link v-if="loggedIn && $route.fullPath!='/logout'">
                        <v-list-item-icon>
                            <v-icon color="white">logout</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">Logout</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$router.push('/login')" link v-if="!loggedIn && $route.fullPath!='/login'">
                        <v-list-item-icon>
                            <v-icon color="white">logout</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">Login</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$router.push('/register')" link
                                 v-if="!loggedIn && $route.fullPath!='/register'">
                        <v-list-item-icon>
                            <v-icon color="white">account_box</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">Register</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="$router.push('/account')" link v-if="loggedIn && $route.fullPath!='/account'">
                        <v-list-item-icon>
                            <v-icon color="white">account_box</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title class="white--text">My Account</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>
            </v-navigation-drawer>

            <router-view :key="$route.fullPath"></router-view>
        </v-content>
    </v-app>
</template>

<script>
    import api from './services/aggrega8-api'

    export default {
        name: 'App',

        components: {},

        data: () => ({
            showMenu: false
        }),
        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            brandingLogo: function () {
                return this.$store.state.brandingLogo
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
            cartSize: function () {
                return this.$store.state.cartSize
            },
            branding: function () {
                return this.$store.state.branding
            }
        },
        async beforeMount() {
            if (!this.loggedIn) {
                let token = localStorage.getItem("api_key")
                if (token) {
                    await this.$store.dispatch("setApiKey", token)
                    await this.$store.dispatch("setLoggedIn", true)
                    await api.getUserDetails()
                }
            }
        },
        mounted() {
            if (!this.branding && !this.$route.path.startsWith("/program")) { // /program sets branding, so avoid race condition
                let lastProgram = localStorage.getItem("program")
                let url = "/consumer/branding"
                if (lastProgram) {
                    url += "/" + lastProgram
                }
                this.$store.dispatch("setExecuting", true)
                api.get(url).then(
                (results) => {
                    this.$store.dispatch("setBranding", results.data)
                },
                () => { /*Error*/
                    this.$store.dispatch("setDefaultBranding")
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            }
        },
        methods: {
            logout() {
                this.$store.dispatch("logout", true)
                this.$router.push("/logout")
            }
        }
    };
</script>

<style>

    @media only screen and (max-width: 599px) {
        .logo-top {
            padding-top: 5px;
            height: 50px;
        }
    }

    @media only screen and (min-width: 600px) {
        .logo-top {
            padding-top: 5px;
            height: 70px;
        }
    }

</style>
